import { render, staticRenderFns } from "./BusinessWorkspace.vue?vue&type=template&id=e72b1e54"
import script from "./BusinessWorkspace.vue?vue&type=script&lang=js"
export * from "./BusinessWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports